var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPullover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 509.775 509.775",
    height: 512,
    viewBox: "0 0 509.775 509.775",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa68e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.775,
    x2: 254.775,
    xlinkHref: "#lg1",
    y1: 466.853,
    y2: 506.713
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3549,
    stopColor: "#80572f",
    stopOpacity: 0.355
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    stopColor: "#603813",
    stopOpacity: 0.995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#603813"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.831,
    x2: 284.112,
    xlinkHref: "#lg2",
    y1: 476.209,
    y2: 591.095
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.497,
    x2: 243.972,
    xlinkHref: "#lg2",
    y1: 471.891,
    y2: 555.23
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.775,
    x2: 254.775,
    xlinkHref: "#lg2",
    y1: 490.144,
    y2: 541.671
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#e2a06e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4015,
    stopColor: "#bd8557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#a27247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8412,
    stopColor: "#92663d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.008,
    x2: 418.001,
    xlinkHref: "#lg3",
    y1: 98.401,
    y2: 674.928
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.972,
    x2: 270.465,
    xlinkHref: "#lg1",
    y1: 230.572,
    y2: 314.575
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.972,
    x2: 270.465,
    xlinkHref: "#lg1",
    y1: 161.163,
    y2: 245.166
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.775,
    x2: 254.775,
    xlinkHref: "#lg2",
    y1: 445.148,
    y2: 492.781
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 427.588,
    x2: 343.907,
    xlinkHref: "#lg2",
    y1: 417.502,
    y2: 333.821
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.674,
    x2: 167.978,
    xlinkHref: "#lg2",
    y1: 455.416,
    y2: 347.72
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.464,
    x2: 89.797,
    xlinkHref: "#lg2",
    y1: 168.225,
    y2: 292.891
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.471,
    x2: 88.137,
    xlinkHref: "#lg2",
    y1: 213.287,
    y2: 259.287
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.257,
    x2: 421.924,
    xlinkHref: "#lg2",
    y1: 211.84,
    y2: 260.507
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 -2223.932 -3683.367)",
    gradientUnits: "userSpaceOnUse",
    x1: 1156.377,
    x2: 1156.377,
    xlinkHref: "#lg1",
    y1: -4595.88,
    y2: -4577.381
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 -1815.9 -1889.329)",
    gradientUnits: "userSpaceOnUse",
    x1: 175.628,
    x2: 186.821,
    xlinkHref: "#lg2",
    y1: -3033.68,
    y2: -2992.571
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 -1815.9 -1889.329)",
    gradientUnits: "userSpaceOnUse",
    x1: 177.058,
    x2: 171.713,
    xlinkHref: "#lg2",
    y1: -3036.015,
    y2: -3000.452
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 -1815.9 -1889.329)",
    gradientUnits: "userSpaceOnUse",
    x1: 176.323,
    x2: 176.323,
    xlinkHref: "#lg2",
    y1: -3027.972,
    y2: -3004.058
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(.707 .707 .707 -.707 2630.722 -3683.367)",
    gradientUnits: "userSpaceOnUse",
    x1: 1229.041,
    x2: 1229.041,
    xlinkHref: "#lg1",
    y1: -4523.217,
    y2: -4504.717
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(.707 .707 .707 -.707 2222.69 -1889.329)",
    gradientUnits: "userSpaceOnUse",
    x1: 248.291,
    x2: 259.484,
    xlinkHref: "#lg2",
    y1: -2961.017,
    y2: -2919.908
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(.707 .707 .707 -.707 2222.69 -1889.329)",
    gradientUnits: "userSpaceOnUse",
    x1: 249.722,
    x2: 244.377,
    xlinkHref: "#lg2",
    y1: -2963.352,
    y2: -2927.788
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(.707 .707 .707 -.707 2222.69 -1889.329)",
    gradientUnits: "userSpaceOnUse",
    x1: 248.987,
    x2: 248.987,
    xlinkHref: "#lg2",
    y1: -2955.309,
    y2: -2931.394
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.612,
    x2: 247.668,
    xlinkHref: "#lg3",
    y1: 151.873,
    y2: 715.995
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.542,
    x2: 513.047,
    xlinkHref: "#lg3",
    y1: 73.514,
    y2: 629.601
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.003,
    x2: 324.336,
    y1: 273.945,
    y2: 230.612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a57c52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#febe98"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.433,
    x2: 282.433,
    xlinkHref: "#lg2",
    y1: 191.471,
    y2: -5.529
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.784,
    x2: 295.784,
    xlinkHref: "#lg3",
    y1: 36.115,
    y2: 161.448
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.064,
    x2: 274.718,
    xlinkHref: "#lg2",
    y1: 75.768,
    y2: 106.072
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.791,
    x2: 213.791,
    xlinkHref: "#lg2",
    y1: 53.461,
    y2: 120.794
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.735,
    x2: 278.386,
    xlinkHref: "#lg3",
    y1: 14.633,
    y2: 112.363
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.775,
    x2: 254.775,
    xlinkHref: "#lg2",
    y1: 10.146,
    y2: 54.833
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m364.901 506.625h-220.251c-9.688 0-17.542-7.854-17.542-17.542v-11.469c0-9.688 7.854-17.542 17.542-17.542h220.25c9.688 0 17.542 7.854 17.542 17.542v11.469c0 9.688-7.854 17.542-17.541 17.542z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.583 506.625h-145.615c-8.012 0-14.507-6.495-14.507-14.507v-17.538c0-8.012 6.495-14.507 14.507-14.507h145.616c8.012 0 14.507 6.495 14.507 14.507v17.538c-.001 8.012-6.496 14.507-14.508 14.507z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.974 506.625h55.602c5.235 0 9.479-4.244 9.479-9.479v-27.593c0-5.235-4.244-9.479-9.479-9.479h-55.602c-5.235 0-9.479 4.244-9.479 9.479v27.593c0 5.235 4.244 9.479 9.479 9.479z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.112 506.625h130.069c12.294 0 22.261-6.189 22.261-13.823v-9.453h-255.333v9.453c0 7.634 9.966 13.823 22.261 13.823z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m489.474 148.838c-6.215-7.67-30.994-31.634-30.994-31.634-34.856-34.856-82.13-54.438-131.424-54.438h-144.562c-49.293 0-96.956 19.198-131.424 54.438-7.519 7.688-22.184 22.819-29.734 31.082-6.478 6.647-8.108 17.402-1.545 23.965l54.348 54.348c6.563 6.563 17.204 6.563 23.767 0l7.601-4.65v214.166c0 26.086 21.147 47.234 47.234 47.234h204.067c26.086 0 47.234-21.147 47.234-47.234v-214.166l7.601 4.65c6.563 6.563 17.204 6.563 23.767 0l54.348-54.348c6.564-6.564 5.93-16.519-.284-23.413z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m404.042 240.857-5.752 4.908c-4.159 3.548-10.279 3.548-14.437 0l-13.859-11.825c-14.122-12.044-34.617-12.042-48.728.004l-13.852 11.819c-4.159 3.548-10.28 3.548-14.438-.001l-13.849-11.82c-14.119-12.04-34.613-12.044-48.732.004l-21.066 17.977-21.066-17.975c-14.122-12.051-34.619-12.051-48.734 0l-13.841 11.812c-4.159 3.549-10.28 3.549-14.439 0l-5.737-4.897v47.938c12.425 4.605 26.685 2.376 37.323-6.706l13.843-11.813c4.159-3.549 10.28-3.549 14.438 0l13.845 11.815c14.121 12.053 34.617 12.051 48.734 0l13.847-11.816c4.159-3.549 10.28-3.549 14.439 0l13.847 11.816c14.121 12.05 34.615 12.051 48.732.002l13.855-11.82c4.159-3.548 10.279-3.547 14.437.001l13.856 11.823c7.059 6.024 15.711 9.036 24.366 9.034 4.394 0 8.785-.785 12.971-2.339v-47.941z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.042 171.448-5.752 4.907c-4.159 3.548-10.279 3.548-14.437 0l-13.859-11.825c-14.122-12.044-34.617-12.042-48.728.004l-13.852 11.819c-4.159 3.548-10.28 3.548-14.438-.001l-13.849-11.82c-14.119-12.04-34.613-12.044-48.732.004l-21.066 17.977-21.066-17.975c-14.122-12.051-34.619-12.051-48.734 0l-13.841 11.812c-4.159 3.549-10.28 3.549-14.439 0l-5.737-4.897v47.938c12.425 4.605 26.685 2.376 37.323-6.706l13.843-11.813c4.159-3.549 10.28-3.549 14.438 0l13.845 11.815c14.121 12.053 34.617 12.051 48.734 0l13.847-11.816c4.159-3.549 10.28-3.549 14.439 0l13.847 11.816c14.121 12.05 34.615 12.051 48.732.002l13.855-11.82c4.159-3.548 10.279-3.547 14.437.001l13.856 11.823c7.059 6.024 15.711 9.036 24.366 9.034 4.394 0 8.785-.785 12.971-2.339v-47.94z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m105.508 380.758v55.357c0 26.086 21.147 47.234 47.234 47.234h204.067c26.086 0 47.234-21.147 47.234-47.234v-55.357z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.042 296.716-97.241 97.241 79.243 79.243c10.957-8.65 17.998-22.041 17.998-37.084z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.926 390.409 92.94 92.94h116.942c3.278 0 6.478-.335 9.567-.971l-155.71-155.71z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m51.07 117.204c-9.272 8.426-30.361 31.738-30.361 31.738-6.563 6.563-7.481 16.745-.918 23.309l54.348 54.348c6.563 6.563 17.204 6.563 23.767 0l7.601-4.65v-142.474c-20.068 9.134-38.723 21.663-54.437 37.729z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.507 79.475v142.474 126.744h113.315l14.008-285.927h-50.337c-26.819 0-53.036 5.809-76.986 16.709z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m327.056 62.766h-50.337l13.008 285.927h114.316v-126.744-142.474c-23.95-10.9-50.167-16.709-76.987-16.709z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m176.65 389.502 36.923-36.923c2.34-2.34 6.134-2.34 8.474 0l6.803 6.803c2.34 2.34 2.34 6.134 0 8.474l-36.923 36.923c-2.34 2.34-6.134 2.34-8.474 0l-6.803-6.803c-2.34-2.339-2.34-6.133 0-8.474z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.091 383.061 24.04-24.04c1.935-1.935 5.073-1.935 7.008 0l8.269 8.269c1.935 1.935 1.935 5.073 0 7.008l-24.04 24.04c-1.935 1.935-5.073 1.935-7.008 0l-8.269-8.269c-1.935-1.935-1.935-5.073 0-7.008z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.45 366.702-8.677 8.677c-1.265 1.265-1.265 3.315 0 4.579l10.698 10.698c1.265 1.265 3.315 1.265 4.579 0l8.677-8.677c1.265-1.265 1.265-3.315 0-4.579l-10.698-10.698c-1.264-1.264-3.315-1.264-4.579 0z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.496 366.656-23.126 23.126c-2.186 2.186-1.927 5.989.578 8.494l3.102 3.102 45.397-45.397-3.102-3.102c-2.505-2.505-6.308-2.764-8.494-.578z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m332.901 389.502-36.923-36.923c-2.34-2.34-6.134-2.34-8.474 0l-6.803 6.803c-2.34 2.34-2.34 6.134 0 8.474l36.923 36.923c2.34 2.34 6.134 2.34 8.474 0l6.803-6.803c2.34-2.339 2.34-6.133 0-8.474z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.46 383.061-24.04-24.04c-1.935-1.935-5.073-1.935-7.008 0l-8.269 8.269c-1.935 1.935-1.935 5.073 0 7.008l24.04 24.04c1.935 1.935 5.073 1.935 7.008 0l8.269-8.269c1.935-1.935 1.935-5.073 0-7.008z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.101 366.702 8.677 8.677c1.265 1.265 1.265 3.315 0 4.579l-10.698 10.698c-1.265 1.265-3.315 1.265-4.579 0l-8.677-8.677c-1.265-1.265-1.265-3.315 0-4.579l10.698-10.698c1.264-1.264 3.315-1.264 4.579 0z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.055 366.656 23.126 23.126c2.186 2.186 1.927 5.989-.578 8.494l-3.102 3.102-45.397-45.397 3.102-3.102c2.505-2.505 6.308-2.764 8.494-.578z",
    fill: "url(#SVGID_21_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m27.016 142.119s-.57.586-.675.692c-34.925 35.261-35.271 91.734-.14 126.868l120.724 120.73c12.202 12.203 31.986 12.203 44.189.001l19.635-19.635c12.197-12.197 12.203-31.97.014-44.175z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.343 142.07-.128-.128-184.237 184.465c-12.295 12.311-12.289 32.256.014 44.558l19.252 19.252c12.309 12.309 32.265 12.308 44.573 0l120.533-120.538c35.237-35.24 35.234-92.373-.007-127.609z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.343 142.07-.128-.128-184.428 184.657c-12.189 12.204-12.183 31.978.014 44.175l19.635 19.635c12.202 12.203 31.987 12.202 44.189 0l120.724-120.73c35.238-35.24 35.235-92.373-.006-127.609z",
    fill: "url(#SVGID_24_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m483.349 269.678c31.426-31.427 31.622-77.133 11.332-114.993-1.062-1.981-3.231-4.511-4.922-6.202l-31.279-31.279c-34.856-34.856-82.13-54.438-131.424-54.438h-144.562c-.43 0-.859.013-1.289.016v23.764l242.64 242.64z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m328.347 86.546c-1.62 3.076-3.86 5.449-6.511 6.667-.8.367-1.61.729-2.434 1.081-17.344 7.464-39.926 11.978-64.627 11.978s-47.283-4.514-64.627-11.978c-.823-.352-1.633-.714-2.434-1.081-2.65-1.218-4.89-3.59-6.511-6.667-1.968-3.737-3.014-8.51-2.765-13.524l.246-4.945.144-2.856c.125-2.553.584-5.008 1.332-7.239 1.092-3.262 2.798-6.045 4.966-7.938.023-.02.046-.039.069-.059-.02-.02-.039-.034-.062-.054-3.267-2.851-5.133-8.276-4.854-13.91l.551-11.039.128-2.573c0 .68.134 1.35.397 2.01 1.604 4.03 7.967 7.684 17.593 10.584 11.204 3.37 26.843 5.723 44.547 6.437 6.255.249 16.304.249 22.559 0 17.705-.714 33.343-3.067 44.547-6.437 8.636-2.602 14.645-5.811 16.944-9.352.689-1.052 1.046-2.137 1.046-3.243l.239 4.813.856 17.177.003.065c.353 7.121-2.007 13.967-6.137 17.579-.027.024-.054.047-.082.071 2.607 2.265 4.789 4.669 6.493 7.186.671.993 1.077 2.315 1.146 3.721.252 5.016-.794 9.79-2.762 13.526z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.164 57.976c12.368 14.331 40.721 24.354 73.727 24.354 29.789 0 55.791-8.164 69.669-20.291 4.127-3.613 6.485-10.456 6.132-17.574l-.003-.065-.856-17.171c-.408-.53-.839-1.054-1.289-1.572-2.302 3.539-8.309 6.746-16.941 9.347-11.204 3.37-26.843 5.723-44.547 6.437-6.255.249-16.304.249-22.559 0-17.705-.714-33.343-3.067-44.547-6.437-9.625-2.9-15.987-6.553-17.592-10.582-.179.188-.353.378-.526.568l-.551 11.032c-.279 5.635 1.587 11.059 4.854 13.91.023.02.043.034.062.054-.023.02-.046.039-.069.059-2.167 1.891-3.872 4.671-4.964 7.931z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.775 70.2c34.107 0 63.248-10.702 74.913-25.802l-1.095-21.988c0 4.818-6.783 9.22-17.99 12.594-11.204 3.37-26.843 5.723-44.547 6.437-6.255.249-16.304.249-22.559 0-17.705-.714-33.343-3.067-44.547-6.437-11.207-3.375-17.99-7.777-17.99-12.594l-.678 13.614c-.281 5.634 1.585 11.054 4.855 13.908.02.018.041.036.061.053 13.898 12.086 39.852 20.215 69.577 20.215z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.775,
    cy: 22.408,
    fill: "url(#SVGID_29_)",
    rx: 73.817,
    ry: 19.258
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.408 28.869c0 7.067-28.937 12.797-64.633 12.797s-64.633-5.729-64.633-12.797 28.938-19.318 64.633-19.318 64.633 12.251 64.633 19.318z",
    fill: "url(#SVGID_30_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPullover);
export default __webpack_public_path__ + "static/media/icon-pullover.3cd0c1a096510a006eeece06f98aaea5.svg";
export { ForwardRef as ReactComponent };